var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsnext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 32,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 16,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 48,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 32,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 32 C24 32, 26 16, 31 16",
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32 C24 32, 26 48, 31 48",
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 16 C46 16, 48 32, 52 32",
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48 C46 48, 48 32, 52 32",
    stroke: "currentColor",
    strokeWidth: 3.75,
    fill: "none"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 32,
    r: 3,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsnext);
export default __webpack_public_path__ + "static/media/whatsnext.0efd94f4008e978a294ce7d6ee85af73.svg";
export { ForwardRef as ReactComponent };